import Bridge from './Bridge'

BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.js-nav-edit-replace'), el => new Bridge(el))
})

// const Sortable = BS.Editor.getPlugin("sortablejs");
